import { CoordinatesAlias } from "constant";

import { convertCoordinates } from "./convertCoordinates";

interface getParsedCoordinatesInterface {
  coordinates: number[] | undefined;
  coordinateSystem: CoordinatesAlias;
}

export const getParsedCoordinates = ({
  coordinates,
  coordinateSystem
}: getParsedCoordinatesInterface): string | null => {
  if (
    Array.isArray(coordinates) &&
    coordinates.length >= 2 &&
    coordinates[0] &&
    coordinates[1]
  ) {
    return convertCoordinates(
      [coordinates[0], coordinates[1]],
      coordinateSystem
    );
  }
  return null;
};
